'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var nthBitHeader = require('@narvar/nth-bit-header');
var VisuallyHidden = require('../../../../../../../common/components/VisuallyHidden.js');
var SelectableCard = require('../../../../../../../common/components/SelectableCard.js');
var Typography = require('../../../../../../../common/components/Typography.js');
var Box = require('../../../../../../../common/components/layout/Box/Box.js');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var index = require('../../../../../../../common/components/Icon/index.js');
var ActionOption_module = require('./ActionOption.module.css.js');
var index$1 = require('../../../../../../../common/theme/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const ActionOption = _ref => {
  let {
    selected = false,
    value,
    name,
    onChange,
    title,
    recommended,
    icon
  } = _ref;
  const {
    claimsClaimDetailsReviewRecommendedAction
  } = nthHookTranslations.useTranslations();
  const [focused, setFocused] = React.useState(false);
  return /*#__PURE__*/React__default["default"].createElement("label", {
    htmlFor: value
  }, /*#__PURE__*/React__default["default"].createElement(VisuallyHidden["default"], {
    id: value,
    as: "input",
    type: "radio",
    name: name,
    value: value,
    checked: selected ?? undefined,
    onFocus: () => setFocused(true),
    onBlur: () => setFocused(false),
    onChange: onChange
  }), /*#__PURE__*/React__default["default"].createElement(SelectableCard["default"], {
    selected: selected,
    focused: focused,
    as: "div"
  }, /*#__PURE__*/React__default["default"].createElement(Box["default"], {
    gap: 2,
    className: ActionOption_module["default"].action
  }, /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(index.IconThemed, _extends__default["default"]({
    icon: icon,
    height: "13",
    width: "13"
  }, selected ? undefined : {
    style: {
      fill: index$1.colors.statusIndeterminate
    }
  }))), /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(nthBitHeader.SmallHeader, {
    as: "div"
  }, title), recommended && /*#__PURE__*/React__default["default"].createElement(Typography.CaptionTextDefault, null, claimsClaimDetailsReviewRecommendedAction)), /*#__PURE__*/React__default["default"].createElement("div", null, recommended && /*#__PURE__*/React__default["default"].createElement(index.IconThemed, _extends__default["default"]({
    icon: "Sparkles"
  }, selected ? undefined : {
    style: {
      fill: index$1.colors.statusIndeterminate
    }
  }))))));
};
var ActionOption$1 = nthHookTranslations.withTranslationsProvider(ActionOption, {
  translationKeys: ['claimsClaimDetailsReviewRecommendedAction']
});

exports["default"] = ActionOption$1;
